import { render, staticRenderFns } from "./DmPreislisteDetail.vue?vue&type=template&id=7a6c0490&scoped=true&"
import script from "./DmPreislisteDetail.vue?vue&type=script&lang=js&"
export * from "./DmPreislisteDetail.vue?vue&type=script&lang=js&"
import style0 from "./DmPreislisteDetail.vue?vue&type=style&index=0&id=7a6c0490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6c0490",
  null
  
)

export default component.exports